<script>
export default {
  props: {
    formatNames: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    uploadImage(image) {
      this.$emit('uploadImageTo', image)
    },
    onDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      this.$emit('onDrop', e)
    },
    onChange(e) {
      this.$emit('onChange', e)
    },
    removeFile(image) {
      this.$emit('removeImageTo', image)
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.imagewrapper">
      <div
        :class="$style.bgimage"
        class="file-upload-form"
        @dragover.prevent
        @drop="onDrop"
      >
        <label :class="$style.lblImgLender" for="imgLender">
          <div v-if="!image">
            <b-img
              src="@assets/images/default_img.png"
              :class="$style.noImage"
              center
              class="py-4 my-auto"
            />
          </div>
          <img else :src="image" alt :class="$style.preview" />

          <input
            id="imgLender"
            type="file"
            name="image"
            :disabled="isDisabled"
            accept=".jpeg, .jpg, .png"
            @change="onChange"
          />
        </label>
      </div>
      <p class="text-center" style="margin-top: -45px;">
        Drop image here or
        <label :class="$style.fileContainer">
          Browse
          <input
            type="file"
            class="d-none"
            :disabled="isDisabled"
            accept=".jpeg, .jpg, .png"
            @change="onChange"
          />
        </label>
      </p>
      <p :class="$style.conditions"
        >[Max Size: 1 MB, Width × Height: 100 × 100px]</p
      >
      <p :class="$style.conditions">[File Type: PNG, JPEG, JPG]</p>

      <div class="float-right mr-3 d-flex">
        <BaseEButton
          v-if="image"
          id="btnRemove"
          varaint="cancel"
          class="btn btn-sm mr-2"
          type="button"
          @click="removeFile"
          >REMOVE</BaseEButton
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.fileContainer {
  color: $color-link-text;
  cursor: pointer;
}
.noImage {
  width: 26%;
}
.removeBtn:hover,
.upload:hover {
  color: $color-text-white !important;
  background-color: #5a6268 !important;
  border-color: #545b62 !important;
}
.cancelBtn:hover {
  color: $color-text-white !important;
  background-color: #5a6268 !important;
}
.imagewrapper {
  height: 291px;
  background: #ececec;
}
.bgimage {
  // background-image: url(../images/default_img.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 65px 65px;
}
.lblImgLender {
  width: 40%;
  height: 110px;
  min-height: 102px;
  margin: 10% 30%;
  cursor: pointer;
  border: 1px dashed #999;
  object-fit: contain;
}
.conditions {
  margin-top: -20px;
  font-size: 12px;
  color: grey;
  text-align: center;
}
.preview {
  position: absolute;
  top: 12%;
  left: 40%;
  width: 100px;
  min-width: 100px;
  height: 100px;
  max-height: 100px;
  border-radius: 50%;
}
input[type='file'] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
</style>
